(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/content-handler/assets/javascripts/content-handler.js') >= 0) return;  svs.modules.push('/components/sportinfo/content-handler/assets/javascripts/content-handler.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = svs.core.log.getLogger('sport:sportinfo-content-handler');
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _svs$components$sport = svs.components.sportinfo.configs.ContentConfig,
  getMenuConfig = _svs$components$sport.getMenuConfig,
  getContent = _svs$components$sport.getContent;
const getSportInfoMatchState = svs.components.sportinfo.common.matchState.getSportInfoMatchState;
const config = svs.components.sportinfo.sportinfoContentView.config;
const injectAnalyze = svs.components.sportinfo.configs.InjectTab.injectAnalyze;
const lazy = svs.components.lbUtils.lazy.lazy;
const SkeletonWrapper = svs.components.sportinfo.skeletonWrapper.SkeletonWrapper;
const useExternalMatchIds = svs.components.sport.statisticsCommon.useExternalMatchIds;
const ApiProxy = svs.components.lbUtils.apiProxy.ApiProxy;
const customSporteventApiHandler = svs.components.sportinfo.common.helpers.customSporteventApiHandler;
const ContentHandler = _ref => {
  let matchId = _ref.matchId,
    sportType = _ref.sportType,
    forceSportType = _ref.forceSportType,
    _ref$forceFetchSportE = _ref.forceFetchSportEvent,
    forceFetchSportEvent = _ref$forceFetchSportE === void 0 ? false : _ref$forceFetchSportE,
    sportEventStatus = _ref.sportEventStatus,
    children = _ref.children,
    productId = _ref.productId,
    shouldIncludeExtraStats = _ref.shouldIncludeExtraStats,
    _ref$lazyLoader = _ref.lazyLoader,
    lazyLoader = _ref$lazyLoader === void 0 ? lazy : _ref$lazyLoader;
  const _useState = useState({
      menuItems: [],
      content: {},
      matchStateProps: {},
      lazyComponentsMap: undefined
    }),
    _useState2 = _slicedToArray(_useState, 2),
    contentConfig = _useState2[0],
    setContentConfig = _useState2[1];
  const _useExternalMatchIds = useExternalMatchIds(matchId, productId),
    externalId = _useExternalMatchIds.externalId;
  const setContentStates = React.useCallback((sportType, sportEventStatus) => {
    const finalSportType = forceSportType !== null && forceSportType !== void 0 ? forceSportType : sportType;
    const matchState = getSportInfoMatchState(sportEventStatus);
    let filteredMenuItems = getMenuConfig({
      sportType: finalSportType,
      productId,
      providerIds: externalId,
      matchState
    });
    let filteredContent = getContent({
      sportType: finalSportType,
      matchState,
      productId,
      providerIds: externalId
    });
    if (shouldIncludeExtraStats) {
      var _injectAnalyze = injectAnalyze(filteredMenuItems, filteredContent, matchState);
      filteredMenuItems = _injectAnalyze.menuItems;
      filteredContent = _injectAnalyze.content;
    }
    const _lazyComponentsMap = new Map();
    Object.keys(filteredContent).forEach(tab => {
      filteredContent[tab].forEach(content => {
        const componentConfig = config[content.provider](content.type);
        if (componentConfig) {
          const component = componentConfig.component,
            componentRef = componentConfig.componentRef,
            skeletonConfig = componentConfig.skeletonConfig;
          const config = skeletonConfig(content.type);
          _lazyComponentsMap.set(component, lazyLoader(component, componentRef, {
            fallback: () => React.createElement(SkeletonWrapper, {
              config: config
            })
          }));
        }
      });
    });
    setContentConfig({
      menuItems: filteredMenuItems,
      content: filteredContent,
      matchStateProps: {
        matchState,
        sportType: finalSportType,
        sportEventStatus
      },
      lazyComponentsMap: _lazyComponentsMap
    });
  }, [externalId, forceSportType, shouldIncludeExtraStats, lazyLoader, productId]);
  useEffect(() => {
    if (matchId && forceFetchSportEvent) {
      const apiProxy = new ApiProxy([customSporteventApiHandler]);
      (async () => {
        try {
          const data = await apiProxy.fetch("/sport/1/sportevent/".concat(matchId), {
            method: 'GET'
          });
          const _data$sportEvent = data.sportEvent,
            sport = _data$sportEvent.sport,
            status = _data$sportEvent.status;
          setContentStates(sport.sportType, status);
        } catch (error) {
          logger.warn("Failed to fetch match with id ".concat(matchId, ": ").concat(error));
        }
      })();
    } else {
      setContentStates(sportType, sportEventStatus);
    }
  }, [matchId, sportType, sportEventStatus, productId, externalId, forceFetchSportEvent, setContentStates]);
  return children(contentConfig);
};
setGlobal('svs.components.sportInfo.contentHandler.ContentHandler', ContentHandler);

 })(window);